<template>
  <div v-if="showPageContent">
    <v-card-title class="pa-0">
      <v-row no-gutters>
        <v-col class="col-auto mr-3">
          <div class="headline font-weight-bold black--text">
            {{ $t("hfManagement.practitionerList") }}
          </div>
        </v-col>
        <v-col v-if="hasWritePerm" class="col-auto">
          <v-btn
            color="primary"
            class="caption font-weight-bold"
            outlined
            rounded
            small
            @click="newDoctorDialog = true"
            >{{ $t("add.default") }}</v-btn
          >
        </v-col>
        <v-col v-if="hasWritePerm" class="col-auto ml-2">
          <v-btn
            color="primary"
            class="caption font-weight-bold"
            outlined
            rounded
            small
            @click="exportExcelStaff()"
            >{{ $t("hfManagement.exportStaffBtn") }}</v-btn
          >
        </v-col>
        <v-col class="col-auto ml-auto">
          <v-btn
            color="primary"
            class="caption font-weight-bold mx-0"
            outlined
            rounded
            small
            @click="staffTableDialog = true"
            >{{ $t("hfManagement.editStaffTableTitle") }}</v-btn
          >
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="pa-0">
      <slot name="filters"></slot>
    </v-card-text>
    <v-card-text class="px-0">
      <transition-group
        name="slide-fade"
        mode="out-in"
        class="doctor-list-container pr-1"
        tag="div"
      >
        <div v-for="(doctorServiceList, key) in grouppedDoctors" :key="key">
          <div :key="key" class="text-uppercase">
            <h2 class="font-weight-bold secondary--text">"{{ key }}"</h2>
          </div>
          <v-divider class="mt-1 mb-4"></v-divider>
          <transition-group name="slide-fade" mode="out-in">
            <doctor-list-item
              v-for="doctorServiceItem in doctorServiceList"
              :key="doctorServiceItem.doctorId"
              :doctorServiceItem="doctorServiceItem"
              @openeditdoctordialog="openEditDoctorDialog"
            />
          </transition-group>
        </div>
      </transition-group>
      <!--<div v-if="!hasDoctors">
        <h2 class="font-italic font-weight-light">
          {{ $t("hfManagement.emptyDoctorListMsg") }}
        </h2>
      </div>-->
    </v-card-text>

    <staff-table
      :officeId="officeId"
      :visible="staffTableDialog"
      :hasWritePerm="hasWritePerm"
      @close="staffTableDialog = false"
    />

    <new-doctor-modal
      :hasWritePerm="hasWritePerm"
      :newDoctorDialog="newDoctorDialog"
      :officeId="officeId"
      @closenewdoctordialog="newDoctorDialog = false"
    />

    <edit-doctor-modal
      :hasWritePerm="hasWritePerm"
      :editDoctorDialog="editDoctorDialog"
      :officeId="officeId"
      :selectedDoctorService="selectedDoctorService"
      @closeeditdoctordialog="closeEditDoctorDialog"
    />
  </div>
</template>

<script>
import HFStaffTable from "./HFStaffTable";
import HFDoctorListItem from "./HFDoctorListItem";
import HFNewDoctorModal from "./HFNewDoctorModal";
import HFEditDoctorModal from "./HFEditDoctorModal";
import groupBy from "lodash/groupBy";
import isEmpty from "lodash/isEmpty";

export default {
  components: {
    StaffTable: HFStaffTable,
    DoctorListItem: HFDoctorListItem,
    NewDoctorModal: HFNewDoctorModal,
    EditDoctorModal: HFEditDoctorModal
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      staffTableDialog: false,
      newDoctorDialog: false,
      editDoctorDialog: false,
      doctor: {
        name: "",
        surname: ""
      },
      selectedDoctorService: {},
      dataLoaded: {
        dimension: false,
        doctorList: false,
        serviceList: false
      }
    };
  },
  created() {
    this.initialize();
  },
  computed: {
    hasWritePerm() {
      return this.$store.getters["auth/userHasRequiredAccess"](
        "GESTIONESTRUTTURASANITARIA",
        "READWRITE"
      );
    },
    officeId() {
      return this.$store.getters["hfManagement/officeId"];
    },
    showPageContent() {
      return (
        this.dataLoaded.dimension &&
        this.dataLoaded.doctorList &&
        this.dataLoaded.serviceList
      );
    },
    grouppedDoctors() {
      return groupBy(this.items, doctorService =>
        doctorService.doctor.surname.charAt(0).toUpperCase()
      );
    },
    hasDoctors() {
      return !isEmpty(this.grouppedDoctors);
    }
  },
  methods: {
    initialize() {
      this.getDimension();
      this.getDoctorServiceList();
      this.getServiceList();
    },
    getDimension() {
      return this.$store
        .dispatch("doctors/fetchDimension", this.officeId)
        .then(() => {})
        .catch(() => {})
        .finally(() => {
          this.dataLoaded.dimension = true;
        });
    },
    getDoctorServiceList() {
      this.$store
        .dispatch("doctors/fetchDoctorServiceList", this.officeId)
        .then(() => {})
        .catch(() => {})
        .finally(() => {
          this.dataLoaded.doctorList = true;
        });
    },
    getServiceList() {
      this.$store
        .dispatch("doctors/fetchServiceList", this.officeId)
        .then(() => {})
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.dataLoaded.serviceList = true;
        });
    },
    closeEditDoctorDialog() {
      this.editDoctorDialog = false;
      this.selectedDoctorService = {};
    },
    openEditDoctorDialog(selectedDoctorService) {
      this.selectedDoctorService = selectedDoctorService;
      this.editDoctorDialog = true;
    },
    async exportExcelStaff() {
      let officeId = this.officeId;
      let hfOffices = this.$store.getters["hfManagement/hfOffices"];
      let officeName = hfOffices.find(o => o.id == officeId).legalName;
      await this.$store.dispatch("doctors/exportOfficeStaffExcelFile", {
        officeId,
        officeName
      });
    }
  }
};
</script>

<style scoped>
.doctor-list-container {
  max-height: 600px;
  overflow-y: auto;
}
</style>
